<script type="text/javascript">

	import FormField from '@smui/form-field';
	import Radio from '@smui/radio';
	import Switch from '@smui/switch';
	import { get,writable } from "svelte/store";
	import AppStore from "../../AppStore";
	import AuthState from "../../Auth/Enums/AuthState";
	import AuthStore from "../../Auth/Store";
	import LoadState from "../../Enums/LoadState";
	import roundFloat from "../../Helpers/Misc/roundFloat";
	import MapLayerGroup from "../../Map/Enums/MapLayerGroup";
	import VisibilityState from "../../Map/Enums/VisibilityState";
	import MapLayerManager from "../../Map/MapLayerManager";
	import MapStore from "../../Map/Store";
	import UserPreferencesStore from "../Dashboards/UserPreferences/Store";
	import MenuItem from "../FlyoutMenu/MenuItem.svelte";
	import ModalWindow from "../ModalWindow.svelte";
	import Spinner from "../Spinner/Spinner.svelte";
	import SpinnerSize from "../Spinner/SpinnerSize";
	import SatelliteViewStore from "./Store";
	import SatelliteViewType from "./Type";
		
	const initted = SatelliteViewStore.meta.initted;
	let viewType = SatelliteViewStore.meta.type;
	let opacity = SatelliteViewStore.meta.opacity;
	let visible = SatelliteViewStore.meta.visible;
	let mapInitialised = MapStore.meta.initialised;
	$: {
		const map = MapStore.helpers.getMap();
		if (map && $mapInitialised) {
			if (!$initted && $user && $loginState === AuthState.LOGGED_IN) {
				updateFromUser();
				SatelliteViewStore.actions.init(map);
			}
			// if ($viewType !== SatelliteViewType.OFF) {
				
			// }
			$opacity;
			$visible;
			SatelliteViewStore.actions.update(map);
		}
	}

	$: {
		if ($user && $loginState === AuthState.LOGGED_IN) {
			updateFromUser();
		}
	}

	const toggleView = e => {
		$viewType = e.target.value;
		
		const map = MapStore.helpers.getMap();
		SatelliteViewStore.actions.update(map);
	};

	let initState = UserPreferencesStore.dashboard.meta.initState;

	$: {
		if ($visible) {
			UserPreferencesStore.dashboard.actions.init();
		}
	}

	let mapZoomLevel = 0;
	let updateZoom = (map) => {
		mapZoomLevel = map.getZoom();
	};
	let gotoZoom3 = () => {
		const map = MapStore.helpers.getMap();
		map.zoomTo(3);
	};
	MapStore.meta.initialised.subscribe((initialised)=>{
		if (initialised) {
			const map = MapStore.helpers.getMap();
			map.on('zoomend', () => { updateZoom(map); });
		}
	});


	const bathymetryLayerId = "10m-bathymetry-81bsvj";
	let bathymetryEnabled = writable(false);
	let bathymetryInitialised = writable(false);
	
	let user = AuthStore.session.user;
	let loginState = AuthStore.meta.state;

	let updateFromUser = () => {
		$viewType = $user.userMapViewType;
		$bathymetryEnabled = $user.userBathymetryEnabled;
		$opacity = $user.userSatelliteViewOpacity;
		console.error("updated from user");
	};
	$: {
		const map = MapStore.helpers.getMap();
		if (map && $mapInitialised && $bathymetryEnabled && !$bathymetryInitialised) {
			map.addSource(bathymetryLayerId, {
				type: 'vector',
				url: 'mapbox://mapbox.9tm8dx88'
			});

			let beforeLayerId = "ttw-areas"; // "land-structure-polygon";
			map.addLayer({
				'id': bathymetryLayerId,
				'type': 'fill',
				'source': bathymetryLayerId,
				'source-layer': bathymetryLayerId,
				'layout': {},
				'paint': {
					'fill-outline-color': 'hsla(337, 82%, 62%, 0)',
					// cubic bezier is a four point curve for smooth and precise styling
					// adjust the points to change the rate and intensity of interpolation
					'fill-color': [
						'interpolate',
						['cubic-bezier', 0, 0.5, 1, 0.5],
						['get', 'DEPTH'],
						200,
						'#78bced',
						9000,
						'#15659f'
					]
				}
			},beforeLayerId);
			map.setLayoutProperty(bathymetryLayerId, "visibility", VisibilityState.VISIBLE);

			MapLayerManager.addLayerGroup(MapLayerGroup.BATHYMETRY, [bathymetryLayerId], [bathymetryLayerId]);


			$bathymetryInitialised = true;
		}
		else if ($bathymetryEnabled && $bathymetryInitialised) {
			map.setLayoutProperty(bathymetryLayerId, "visibility", VisibilityState.VISIBLE);
			// map.setPaintProperty(MapLayer.SATELLITE_TILES, "raster-opacity", opacity);
		}
		else if (!$bathymetryEnabled && $bathymetryInitialised) {
			map.setLayoutProperty(bathymetryLayerId, "visibility", VisibilityState.NONE);
		}
	}
	
	let saveUserPrefs = () => {
		if ($initState !== LoadState.LOADED) {
			console.error("Could not save as user not loaded.");
			return;
		}

		let lngLatFormat = $user.userLngLatFormat;
		UserPreferencesStore.dashboard.actions.savePreferences(lngLatFormat, $bathymetryEnabled, $viewType, $opacity)
			.then(()=>{
				updateFromUser();
				AppStore.snackbar.start("Map Settings saved successfully.", "success");
			})
			.catch((err)=>{
				AppStore.snackbar.start("Map Settings save failed.", "error");
			});
		
	};

</script>

<style type="text/css">
	p.satellite-imagery-data-attribution {
		font-size:8px;
		font-style: italic;
		color:#777;
		margin:0px;
		margin-top:5px;
	}
	p.satellite-imagery-data-attribution a {
		font-size:8px;
	}
</style>


<ModalWindow
	title={`Map Settings`}
	hasCloseButton={true}
	hasBackground={false}
	resizable={true}
	draggable={true}
	fullscreen={false}
	padding={false}
	position="top-right"
	height="70%"
	bind:open={$visible} 
	on:close={saveUserPrefs}
		>
	<MenuItem title={"Map View"} materialIcon={"satellite"}>
		{#if $initState === LoadState.INIT}
			...
		{:else if $initState === LoadState.LOADING}
			<div class="spinner-center">
				<Spinner size={SpinnerSize.SMALL} absolute={false} inline={true} />
			</div>
		{:else}
			<p style='margin-top: 0.25rem;'><b>Satellite</b></p>
			<FormField>
				<Radio on:click={toggleView} bind:group={$viewType} value={SatelliteViewType.OFF} />
				<span slot="label">Basemap</span>
			</FormField>
			<FormField>
				<Radio on:click={toggleView} bind:group={$viewType} value={SatelliteViewType.REGULAR} />
				<span slot="label">Satellite</span>
			</FormField>
			<FormField>
				<Radio on:click={toggleView} bind:group={$viewType} value={SatelliteViewType.SATURATED} />
				<span slot="label">Saturated</span>
			</FormField>
			<FormField>
				<Radio on:click={toggleView} bind:group={$viewType} value={SatelliteViewType.GREYSCALE} />
				<span slot="label">Greyscale</span>
			</FormField>
			<FormField>
				<Radio on:click={toggleView} bind:group={$viewType} value={SatelliteViewType.SEPIA} />
				<span slot="label">Sepia</span>
			</FormField>
			{#if $viewType !== SatelliteViewType.OFF}
				<div class='layer-list-component'>
					<div class="layer-list-item">
						<div class='lli-label'>Opacity</div>
						<div class='lli-switch'>
							<input
								type="range"
								min="0"
								max="100"
								step="1"
								value={$opacity*100}
								style="margin-top:10px"
								on:input={(e) => {
									$opacity = parseFloat(e.target.value) * 0.01;
									let u = get(user);
									u.userSatelliteViewOpacity = $opacity;
								}}>
						</div>
					</div>
				</div>
				<p class='satellite-imagery-data-attribution'>Satellite imagery is from a combination of MODIS (2012–2013), Landsat 5 & 7 (2010–2011), and open and proprietary sources, including Maxar’s GBM and Vivid products for much of the world, Nearmap and USDA’s NAIP 2011–2013 in the contiguous United States, and open aerial imagery from Denmark, Finland, and parts of Germany. The data will be of variable age, with the highest resolution typically less than 30 month; this should be taken into consideration in any assessments.</p>
			{/if}
			<!-- View type: {$viewType} -->
			<br/>

			<p><b>Bathymetry</b></p>
			<div class='layer-list-component'>
				<div class="layer-list-item">
					<div class="lli-label">
						Enabled
					</div>
					<div class="lli-switch">
						<FormField align="end">
							<Switch bind:checked={$bathymetryEnabled} />
						</FormField>
					</div>
				</div>
				{#if $bathymetryEnabled}
					<div class="layer-list-item">
						<div class="lli-label">
							<p style="line-height:1.25rem;font-size:12px;">Note: Bathymetry is only available at <a href="/" on:click|preventDefault={()=>{gotoZoom3();}}>zoom level 3</a> and above. You are at zoom level {roundFloat(mapZoomLevel, 2)}.</p>
						</div>
					</div>
				{/if}
			</div>

		{/if}
		

	</MenuItem>
</ModalWindow>
